// extracted by mini-css-extract-plugin
export default {"container":"N2-z"};